function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "47",
  height: "47",
  viewBox: "0 0 47 47",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M46.097 23.363c0 12.73-10.319 23.049-23.048 23.049C10.319 46.412 0 36.092 0 23.363 0 10.633 10.32.314 23.049.314s23.048 10.32 23.048 23.049z",
  fill: "#FCE400",
  fillOpacity: ".945"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.838 16.34a1.279 1.279 0 000 2.555 1.279 1.279 0 000-2.556zM23.136 17.979a5.39 5.39 0 00-5.384 5.384 5.39 5.39 0 005.384 5.384 5.39 5.39 0 005.385-5.384 5.39 5.39 0 00-5.385-5.384zm0 8.83a3.45 3.45 0 01-3.445-3.446 3.456 3.456 0 013.445-3.446 3.456 3.456 0 013.446 3.446 3.456 3.456 0 01-3.446 3.446z",
  fill: "#2600A1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.41 34.29h-8.724a6.57 6.57 0 01-6.565-6.565v-8.724a6.57 6.57 0 016.565-6.566h8.725a6.57 6.57 0 016.565 6.566v8.724a6.57 6.57 0 01-6.565 6.565zM18.687 14.49A4.52 4.52 0 0014.174 19v8.724a4.52 4.52 0 004.512 4.512h8.725a4.52 4.52 0 004.512-4.512v-8.724a4.52 4.52 0 00-4.512-4.512h-8.725z",
  fill: "#2600A1"
}));